// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * cm-coding: Global administrators publish a message seen across DocReview from
 * this system page. The route supplies the shared administration background
 * and page heading, while the site-banner subsystem supplies only the editor;
 * giving the editor another title would make one site-wide message look like
 * two separate settings.
 */
import { SiteBannerAdmin } from '@/subsystems/site-banner'

export default function SiteBannerPage() {
  return (
    <div className="min-h-full bg-slate-50 text-slate-900">
      <div className="mx-auto max-w-[1280px] px-6 pt-9 pb-16 sm:px-10">
        <h1
          className="text-[21px] font-[650] tracking-[-0.015em]"
          data-testid="site-banner-page-heading"
        >
          Site Banner
        </h1>
        <p className="mt-[5px] text-[13px] text-slate-500">
          Show a global message to every user — useful for announcing releases or maintenance
          windows.
        </p>
        <div className="mt-6">
          <SiteBannerAdmin />
        </div>
      </div>
    </div>
  )
}
